import React, { Component } from "react";
import { Link } from 'react-router-dom';
import {toJS} from 'mobx';
import { Document } from 'firestorter';
import {
  Form,
  Spin,
  Button,
  Input,
  Tag,
  Icon,
  Divider,
  Avatar,
  Select,
  DatePicker,
  Switch,
  Rate,
  notification,
  Collapse,
  Checkbox
} from "antd";

import moment from 'moment';

const Panel = Collapse.Panel;
const FormItem = Form.Item;
const Option = Select.Option;
const { TextArea } = Input;
const CheckboxGroup = Checkbox.Group;
String.prototype.capitalize = function() {
    return this.charAt(0).toUpperCase() + this.slice(1);
}

class contractForm extends Component {
  constructor(props) {
    super(props);
    console.log("props", this.props);
    this.initialProps = Object.assign(this.props.request || {}, {inputVisible: false, inputValue: null, usersEmail:{}});
    this.state = Object.assign(this.props.request || {}, {inputVisible: false, inputValue: null, usersEmail:{}});
    this.handleSubmit = this.handleSubmit.bind(this);
    this.recurring = this.recurring.bind(this);
    this.single = this.single.bind(this);
  }
  componentWillReceiveProps(nextProps){
    console.log('componentWillReceiveProps', nextProps);
    if(nextProps.request){
      console.log("HELLLO",this.initialProps);
      console.log('nextProps', nextProps);
      this.setState(Object.assign(this.initialProps, nextProps.request));
      console.log('statttt',this.state);
      if(this.state.author){
        this.getUser(this.state.author, "getAuthor");
      }
      if(this.state.nurse){
        this.getUser(this.state.nurse.id, "getNurse");
      }
    }
  }
  componentWillUnmount(){
    this.setState(null);
  }
  async getUser(userId, field) {
      var userDocument = new Document("users/" + userId, {
        mode: "off"
      });
      const user = await userDocument.fetch();
      if(user.data) {
        console.log("user ",user.data);
        this.setState({[field]: user.data})
      }
    }
  // componentDidUpdate(prevProps,prevState, snapshot){
  //   if(!!this.props.disabled && this.state != this.initialProps){
  //     this.setState(Object.assign(this.props.request || {}, {inputVisible: false, inputValue: null, usersEmail:{}}));
  //   }
  //   console.log('prevProps', prevProps.request);
  //   console.log('prevState', prevState);
  // }
  handleSubmit = async (event) => {
    event.preventDefault();
    this.setState({loading: true});
    const clone = Object.assign(this.state)
    delete clone.inputVisible;
    delete clone.inputValue;
    delete clone.loading;
    delete clone.disabled;
    delete clone.usersEmail;
    delete clone.getAuthor;
    delete clone.getNurse;

    console.log('CLONE is:', clone);
    console.log('CLONE DATE', );
    if(!(clone.startTime instanceof Date) || !(clone.endTime instanceof Date)) {
      notification.error({
        message: "Impossible d'effectuer l'opération",
        description: "Date mal formatée"
      })
      return false;
    }
    try {
      await this.props.submit(clone);
    } catch(e) {
      console.log('Error', e.message);
      notification.error({
        message: "Impossible d'effectuer l'opération",
        description: e.message
      })
      this.setState({loading: false});
      return false;
    }
    this.setState({loading: false});
    notification.success({
      message: "Opération réussie"
    })
    this.props.closeModal ? this.props.closeModal() : null;
    this.setState(this.props.request ? {...this.props.request} : {...Object.keys(this.state).forEach(v => this.state[v] = null)} )
  }

  taskOptions = [
    'Ménage',
    'Courses',
    'Entretien du linge',
    'Promenade',
    'Repas',
    'Aide à la toilette',
    'Aide au lever',
    'Aide au coucher',
    'Compagnie de jour',
    'Compagnie de nuit'
  ];
  single() {
    return(
      [<FormItem label="Récurrence" key='recurring'>
          <span>Ponctuelle</span>
        </FormItem>,
        <FormItem label="Début" key='start'>
          <DatePicker showTime disabled={!!this.props.disabled} format="YYYY-MM-DD HH:mm" value={moment(this.state.startTime) || null} onChange={value => this.setState({startTime: value ? value.toDate() : null})} />
        </FormItem>,
        <FormItem label="Fin" key='end'>
          <DatePicker showTime disabled={!!this.props.disabled} format="YYYY-MM-DD HH:mm" value={moment(this.state.endTime) || null} onChange={value => this.setState({endTime: value ? value.toDate() : null})} />
        </FormItem>
      ]
    )
  }
  recurring() {
    var weekDur = 0;


    return(
      [
    <FormItem label="Récurrence" key='recurring'>
        <ul>
          {this.state.appointments.map((app, i) => {
            weekDur = weekDur + Number(app.duration);
            var time = moment().weekday(app.time.split('.')[0]).hour((app.time.split('.')[1])).minute(app.time.split('.')[2]);
            return (<li><span key={'day'+i}>{time.format('dddd HH[h]mm').capitalize()} - {time.add(app.duration, 'hours').format('HH[h]mm')}</span></li>)
          })}
        </ul>
      </FormItem>,
      <FormItem label="Date de début" key='startdate'>
        <DatePicker showTime disabled={true} format="YYYY-MM-DD HH:mm" value={moment(this.state.startDate) || null} onChange={value => this.setState({startDate: value ? value.toDate() : null})} />
      </FormItem>
    ]
    )
  }
  render() {
    console.log('RE RENDER FORM')
    // const authorInfo = this.state.getAuthor ? this.state.getAuthor.firstname + " " + this.state.getAuthor.lastname + " (" + this.state.author + ")": "";
    // const nurseInfo = this.state.getNurse ? this.state.getNurse.firstname + " " + this.state.getNurse.lastname + " (" + this.state.nurse.id +")": "";
    const authorInfo = this.state.getAuthor ? this.state.getAuthor.firstname + " " + this.state.getAuthor.lastname: "";
    const nurseInfo = this.state.getNurse ? this.state.getNurse.firstname + " " + this.state.getNurse.lastname: "";

    return (
      <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
        <Form layout={!!this.props.disabled ? "horizontal" : "vertical"} onSubmit={this.handleSubmit} style={{ maxWidth: 800 }} className={!!this.props.disabled? 'readOnlyForm': null}>
      {/*    <FormItem label="Email">
            <Input
              value={this.state.email || ''}
              disabled={!!this.props.disabled}
              onChange={event => this.setState({email: event.target.value })}
              />
          </FormItem>
          */}


            <FormItem label="Client">
               <Link to={'/users/'+this.state.author}>Voir client</Link>
                <Input
                  value={this.props.disabled ? authorInfo || "Chargement..." : this.state.author || ''}
                  disabled={!!this.props.disabled}
                  onChange={event => this.setState({author: event.target.value })}
                  />
                  {this.props.disabled ? <Input
                    value={this.state.getAuthor ? this.state.getAuthor.email : "Chargement..."}
                    disabled={true}
                    /> : null }
                    {this.props.disabled ? <Input
                      value={this.state.getAuthor ? this.state.getAuthor.phonenumber : "Chargement..."}
                      disabled={true}
                      /> : null }
            </FormItem>


          <FormItem label="Intervenant">
            <Link to={'/users/'+this.state.nurse.id}>Voir intervenant</Link>
                <Input
                  value={this.props.disabled ? nurseInfo || "Chargement..." : this.state.nurse.id || ''}
                  disabled={!!this.props.disabled}
                  onChange={event => this.setState({nurse: {id: event.target.value} })}
                  />
                  {this.props.disabled ? <Input
                    value={this.state.getNurse ? this.state.getNurse.email : "Chargement..."}
                    disabled={true}
                    /> : null }
                    {this.props.disabled ? <Input
                      value={this.state.getNurse ? this.state.getNurse.phonenumber : "Chargement..."}
                      disabled={true}
                      /> : null }
          </FormItem>
          {this.state.isRecurring ? this.recurring() : this.single()}
          {/*<FormItem label="Code Postal">
                <Input
                  value={this.state.getAuthor ? this.state.getAuthor.zipCode : "Chargement..."}
                  disabled={true}
                  />
          </FormItem>*/}


          <FormItem label='Tâches'>
            <CheckboxGroup disabled={!!this.props.disabled} options={this.taskOptions} value={toJS(this.state.tasks)} onChange={(values) => {
                console.log('values', values);
                this.setState({tasks: values});
              }} />
          </FormItem>
          <FormItem label="Informations complémentaires">
                <Input
                  value={this.state.additionalDetails}
                  disabled={!!this.props.disabled}
                  onChange={event => this.setState({additionalDetails: event.target.value })}
                  />
          </FormItem>
          {this.props.children}
          <FormItem label="Contrat Terminé ? ">
            <Switch disabled={!!this.props.disabled} checkedChildren={<Icon type="check" />} unCheckedChildren={<Icon type="cross" />} checked={!!this.state.isContractTerminated} onChange={value => this.setState({isCancelled: value})} />
          </FormItem>
          {!!this.props.disabled ? null :
          <FormItem style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-end'}}>
            <a onClick={() => {this.props.closeModal ? this.props.closeModal() : null;  this.props.switchFunc ? this.props.switchFunc() : null}} style={{margin: 25}}><u>Annuler</u></a>
            <Button type="primary" size='large' htmlType="submit" loading={this.state.loading}>Enregistrer</Button>
          </FormItem> }
        </Form>

      </div>
    );
  }
}
const RequestForm = Form.create()(contractForm);
export default RequestForm;



// WEBPACK FOOTER //
// ./src/ContractForm.js